<template>
    <div class="vh-flex leftpanel">
        <!--软件logo-->
        <div class="vlogo">
            <img style="width: 20px;" src="@/assets/images/app_logo64.png" alt="应用Logo" />
            <div class="lbappname">ComeKey</div>
        </div>
        <div class="vh-full vh-flex menupanel">
            <!--用户信息-->
            <div class="dvuser">
                <img class="useravater" src="@/assets/images/avatar_default1.png" />
                <div class="lbusername">{{ user.nickName }}</div>
            </div>
            <div class="menus">
                <div v-for="item in listNavMenu" @click="menuClick(item)" :key="item.key" class="menuitem"
                    :class="{ 'selected': item.key == selectedKey }">
                    <SvgIcon :svgname="item.icon" :icon-size="item.iconSize"
                        :fill="item.key == selectedKey ? 'white' : 'var(--ek-text-color2)'" />
                    <div class="lbmenuname">{{ item.name }}</div>
                </div>
            </div>
        </div>
        <!--使用说明-->
        <div class="howuse">
            <HowUseCard></HowUseCard>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import localUser from '@/commom/local/LocalUser';
import HowUseCard from '@/components/illustration/HowUseCard.vue';
export default {
    name: 'MainLeftPanel',
    components: {
        SvgIcon,
        HowUseCard
    },
    props: {
        listNavMenu: Array,
        selectedKey: String,
    },
    data() {
        return {
            user: {
                nickName: ""
            }
        }
    },
    mounted: function () {
        this.init()
    },
    methods: {
        ///初始化
        init: function () {
            this.loadPrefrom()
        },
        ///加载用户信息
        loadPrefrom: function () {
            var user = localUser.getLocalUser()
            this.user.nickName = user.nickName
        },
        ///提交事件
        emitEvent: function (name, data) {
            var req = {
                name: name,
                data: data,
            }
            this.$emit("eventHandle", req)
        },
        ///菜单点击
        menuClick: function (item) {
            this.emitEvent("menuClick", item)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.leftpanel {
    width: 230px;
}

.dvuser {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 30px;
}

.menuitem {
    display: flex;
    padding-left: 25px;
    height: 45px;
    border-radius: 10px;
    align-items: center;
    margin-bottom: 10px;
    color: var(--ek-text-color2);
    cursor: pointer;
}

.menus {
    padding-left: 20px;
    padding-right: 20px;
}


/* 横屏平板 */
@media (min-width: 900px) and (max-width: 1200px) and (orientation: landscape) {
    .leftpanel {
        width: 75px;
    }

    .lbmenuname {
        display: none;
    }

    .dvuser {
        display: none;
    }

    .howuse {
        display: none;
    }

    .menuitem {
        padding-left: 0px;
        justify-content: center;
        padding-right: 0px;
    }
    .menus{
        padding-left: 15px;
        padding-right: 10px;
        padding-top: 50px;
    }
    .lbappname{
        display: none;
    }
}


.menupanel {
    /* background: var(--ek-mainbody-bgcolor); */
    border-radius: 10px;
    margin-left: 0px;
    margin-bottom: 20px;
}

.lbusername {
    font-size: 14px;
    margin-top: 10px;
    color: var(--ek-text-color1);
}



.vlogo {
    display: flex;
    padding-left: 23px;
    align-items: center;
    height: 48px;
}

.lbappname {
    font-size: 14px;
    margin-left: 5px;
    font-weight: bold;
    color: var(--ek-text-color2);
}

.useravater {
    width: 50px;
    border-radius: 60px;
    border: 3px solid var(--ek-text-color3);
}



.menuitem:not(.selected):hover {
    background: var(--ek-card-color2);
}

.selected {
    background: var(--ek-color-primary);
    color: white;
}

.lbmenuname {
    margin-left: 5px;
    font-size: 14px;
}
</style>
